/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  itemDropdownType: {
    '& + p': {
      marginBottom: Tokens.spacing['$sp-3'],
    },
  },
  rootInputName: {
    marginBottom: Tokens.spacing['$sp-4'],
    '& p': {
      lineHeight: '10px'
    },
    '& input': {
      paddingBottom: '3px'
    },
  },
  rootInputAddress: {
    visibility: 'hidden',
    '& p': {
      lineHeight: '10px'
    },
    '& input': {
      paddingBottom: '3px'
    },
  },
  paperDropdown: {
    width: '410px !important',
    marginTop: '-26px'
  },
  loader: {
    position: 'absolute',
    // bottom: theme.spacing(),
    left: 0,
    right: 0
  },
  checkBoxDescription: {
    color: 'rgba(44, 50, 62, 0.74)'
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-2'],
    padding: Tokens.spacing['$sp-2'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.text.primary,
    backgroundColor: Palette.colors.orange['50'],
    border: `1px solid ${theme.palette.warning.main}`,
  },
  warningIcon: {
    marginRight: 10,
    color: theme.palette.warning.main,
  }
}));
